/* Vertrauens-Block + Payment-Icons unter der Teeinblue-Kaufbox (Daniel, 2026-11-01/02).
   Nur wahre Aussagen (stehen auch auf der Startseite), keine erfundenen Bewertungen.
   Reihenfolge direkt unter den Buttons: Payment-Icons -> Haken-Leiste -> "So entsteht dein Shirt".

   Technik: Der Block wird INNEN ins Teeinblue-Formular gehaengt, direkt nach den Buttons
   (#teeFormActions) - so wandert er mit, wenn Teeinblue das Formular vom versteckten
   Container an die sichtbare Stelle schiebt. Die Theme-Payment-Icons
   (ul.icon-list-custom-payment_icons_*) werden NICHT verschoben, sondern in den Block
   KOPIERT und das Original ausgeblendet - dadurch geht bei einem Teeinblue-Re-Render
   nichts verloren (das Original bleibt als Quelle immer im DOM).
   Abstaende grosszuegig (Daniel, 2026-11-02): mehr Luft an allen Uebergaengen, auch mobil.
   Ausloeser: kurzes Polling + MutationObserver (bewusst OHNE requestAnimationFrame,
   das in einem Hintergrund-Tab pausiert).
   Eingebunden in sections/apportino-commerce-loader.liquid. */
(function () {
  var MARK = 'apportino-trust';
  var HTML =
    '<div class="apt-pay"></div>' +
    '<ul class="apt-trust-list">' +
      '<li><span class="apt-tick" aria-hidden="true">✓</span><span><strong>Vorschau vor dem Kauf</strong> – du siehst dein Design, bevor du zahlst.</span></li>' +
      '<li><span class="apt-tick" aria-hidden="true">✓</span><span><strong>Sichere Zahlung</strong> mit PayPal, Klarna &amp; Kreditkarte.</span></li>' +
      '<li><span class="apt-tick" aria-hidden="true">✓</span><span><strong>Für dich einzeln gefertigt</strong> – erst nach deiner Bestellung gedruckt.</span></li>' +
      '<li><span class="apt-tick" aria-hidden="true">✓</span><span><strong>Versandkostenfrei ab 50 €</strong> innerhalb Deutschlands.</span></li>' +
    '</ul>' +
    '<div class="apt-how">' +
      '<div class="apt-how-title">So entsteht dein Shirt</div>' +
      '<div class="apt-steps">' +
        '<div class="apt-step"><span class="apt-num">1</span><span>Foto deines Hundes hochladen</span></div>' +
        '<div class="apt-step"><span class="apt-num">2</span><span>Vorschau prüfen – passt alles?</span></div>' +
        '<div class="apt-step"><span class="apt-num">3</span><span>Wir drucken &amp; liefern zu dir</span></div>' +
      '</div>' +
    '</div>';
  var CSS =
    '.apt-pay-hidden{display:none!important;}' +
    '.apportino-trust{margin:3rem 0 3.4rem;}' +
    '.apportino-trust .apt-pay{margin:0 0 3.2rem;}' +
    '.apportino-trust .apt-pay ul{margin:0!important;padding:0!important;}' +
    '.apportino-trust .apt-trust-list{list-style:none;margin:0;padding:.3rem 0;border:1px solid rgba(30,30,29,.12);border-radius:12px;background:#fff;}' +
    '.apportino-trust .apt-trust-list li{display:flex;gap:1.2rem;align-items:flex-start;padding:1.8rem 1.9rem;font-size:1.4rem;line-height:1.5;color:rgb(30,30,29);}' +
    '.apportino-trust .apt-trust-list li + li{border-top:1px solid rgba(30,30,29,.08);}' +
    '.apportino-trust .apt-tick{flex:0 0 auto;width:2.1rem;height:2.1rem;border-radius:50%;background:#eef4ef;color:#2f7d5b;display:flex;align-items:center;justify-content:center;font-size:1.2rem;font-weight:700;margin-top:.1rem;}' +
    '.apportino-trust .apt-trust-list strong{font-weight:600;}' +
    '.apportino-trust .apt-how{margin-top:3.6rem;}' +
    '.apportino-trust .apt-how-title{font-size:1.4rem;font-weight:600;margin-bottom:1.4rem;color:rgb(30,30,29);}' +
    '.apportino-trust .apt-steps{display:flex;gap:1.2rem;}' +
    '.apportino-trust .apt-step{flex:1;display:flex;flex-direction:column;align-items:center;text-align:center;gap:.9rem;background:#fff;border:1px solid rgba(30,30,29,.12);border-radius:12px;padding:2.2rem 1.1rem;font-size:1.2rem;line-height:1.4;color:rgb(30,30,29);}' +
    '.apportino-trust .apt-num{flex:0 0 auto;width:2.6rem;height:2.6rem;border-radius:50%;background:#2b2b2e;color:#fff;display:flex;align-items:center;justify-content:center;font-weight:700;font-size:1.3rem;}' +
    '.delivery-container{margin:3rem 0!important;}' +
    '@media (max-width:749px){' +
      '.apportino-trust .apt-steps{gap:.8rem;}' +
      '.apportino-trust .apt-step{padding:1.8rem .7rem;font-size:1.15rem;}' +
      '.apportino-trust .apt-trust-list li{padding:1.6rem 1.5rem;}' +
    '}';

  function addStyle() {
    if (document.getElementById('apportino-trust-style')) {
      document.getElementById('apportino-trust-style').textContent = CSS;
      return;
    }
    var s = document.createElement('style');
    s.id = 'apportino-trust-style';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function run() {
    var actions = document.getElementById('teeFormActions');
    if (!actions || !actions.parentNode) return false;
    if (document.querySelector('.' + MARK)) return true;
    addStyle();

    var box = document.createElement('div');
    box.className = MARK;
    box.innerHTML = HTML;
    actions.parentNode.insertBefore(box, actions.nextSibling);

    var orig = null;
    document.querySelectorAll('ul[class*="icon-list-custom-payment_icons"]').forEach(function (u) {
      if (!orig && !box.contains(u)) orig = u;
    });
    if (orig) {
      var clone = orig.cloneNode(true);
      clone.removeAttribute('id');
      box.querySelector('.apt-pay').appendChild(clone);
      orig.classList.add('apt-pay-hidden');
    }
    return true;
  }

  function boot() {
    run();
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (run() || tries > 40) clearInterval(timer);
    }, 300);
    try {
      new MutationObserver(function () { run(); })
        .observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
